import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../helper/apiCall";
import ENDPOINTS from "../../constants/endpoints";

const initialState = {
    loading: false,
    trainers: [],
    selectedTrainer: null,
    error: null
};

export const getTrainers = createAsyncThunk(
    "getTrainers",
    async (arg, thunkAPI) => {
        try {
            const { branchId, placeId } = arg || {};
            const params = new URLSearchParams();
            if (branchId) params.append('branchId', branchId);
            if (placeId) params.append('placeId', placeId);
            const query = params.toString() ? `?${params.toString()}` : '';
            const response = await client.get(`${ENDPOINTS.TRAINERS.GET_LIST}${query}`, {
                token: thunkAPI.getState().auth.token
            });
            // API pagination formatında döndüğü için items array'ini alıyoruz
            return response.data.items || response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const deleteTrainer = createAsyncThunk(
    "deleteTrainer",
    async (id, thunkAPI) => {
        try {
            const response = await client.delete(ENDPOINTS.TRAINERS.DELETE.replace(':id', id), null, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const addTrainer = createAsyncThunk(
    "addTrainer",
    async (trainerData, thunkAPI) => {
        try {
            const response = await client.post(ENDPOINTS.TRAINERS.CREATE, trainerData, {
                token: thunkAPI.getState().auth.token
            });
            
            // Response'dan gelen id ile request body'yi birleştir
            const result = {
                id: response.data.id,
                ...trainerData
            };
            return result;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const updateTrainer = createAsyncThunk(
    "updateTrainer",
    async (trainerData, thunkAPI) => {
        try {
            const response = await client.put(ENDPOINTS.TRAINERS.UPDATE, trainerData, {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

export const getTrainerById = createAsyncThunk(
    "getTrainerById",
    async (id, thunkAPI) => {
        try {
            const response = await client.get(ENDPOINTS.TRAINERS.GET_BY_ID.replace(':id', id), {
                token: thunkAPI.getState().auth.token
            });
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.response?.data || error.message);
        }
    });

const trainersSlice = createSlice({
    name: "trainers",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        clearSelectedTrainer: (state) => {
            state.selectedTrainer = null;
        },
        setSelectedTrainer: (state, action) => {
            state.selectedTrainer = action.payload;
        }
    },
    extraReducers(builder) {
        builder.addCase(getTrainers.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getTrainers.fulfilled, (state, action) => {
            state.loading = false;
            state.trainers = action.payload;
        });
        builder.addCase(getTrainers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(deleteTrainer.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(deleteTrainer.fulfilled, (state, action) => {
            state.loading = false;
            // Silinen trainer'ı listeden çıkar
        });
        builder.addCase(deleteTrainer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(addTrainer.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(addTrainer.fulfilled, (state, action) => {
            state.loading = false;
            // Yeni trainer'ı listeye ekle
        });
        builder.addCase(addTrainer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(getTrainerById.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(getTrainerById.fulfilled, (state, action) => {
            state.loading = false;
            state.selectedTrainer = action.payload;
        });
        builder.addCase(getTrainerById.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
        
        builder.addCase(updateTrainer.pending, (state, action) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(updateTrainer.fulfilled, (state, action) => {
            state.loading = false;
            // Güncellenen trainer'ı listede güncelle
            
        });
        builder.addCase(updateTrainer.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export const { clearError, clearSelectedTrainer, setSelectedTrainer } = trainersSlice.actions;
export default trainersSlice.reducer; 